import { render, staticRenderFns } from "./specialLayout.vue?vue&type=template&id=31f6e9ac&"
import script from "./specialLayout.vue?vue&type=script&lang=js&"
export * from "./specialLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports